module.exports = VueResource;